<ion-content [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}">

  <!-- <swiper-container #swiper [speed]="500" [loop]="false" [allowSlideNext]="allowSwipe" [allowSlidePrev]="false" (afterinit)="swiperReady()">
  
  </swiper-container> -->

  <!-- <ion-slides #slides [options]="slideOpts" > -->
    <!-- <ion-slide> -->

      <swiper-container #swiper [speed]="500" [loop]="false" [allowSlideNext]="allowSwipe" [allowSlidePrev]="false">

          <swiper-slide>
            <div>
              <img id="ticket-img" src="../../../assets/icon/favicon.png" alt="">
              <h2>AFS-Ticketsystem</h2>
              <p>Egal ob verwalten von Tickets, Kunde oder Terminen. Mit dem AFS-Ticketsystem ist dies und viele weitere Tätigkeiten kein Problem mehr.</p>
              <ion-button mode="ios" (click)="toServerConfig()">
                Einrichten 
                <ion-icon name="fa-arrow-right" slot="end"></ion-icon>
              </ion-button>
              <ion-button mode="ios" (click)="finish(2)" style=" margin-top: 15px;" *ngIf="!platform.is('electron')">
                QR-Code scannen
                <ion-icon style="height: 18px;" name="fa-qr-code" slot="start"></ion-icon>
              </ion-button>
              <ion-button style="margin-top: 15px" color="none" mode="ios"  fill="clear" (click)="finish(1)" >
                Demo starten
                <ion-icon name="fa-arrow-right" slot="end"></ion-icon>
              </ion-button> 
            </div> 
          </swiper-slide>

          <swiper-slide>
            <div style="text-align: left;">
              <svg style="height: 30px; margin: none" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wifi" class="svg-inline--fa fa-wifi fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M319.1 351.1c-35.35 0-64 28.66-64 64.01s28.66 64.01 64 64.01c35.34 0 64-28.66 64-64.01S355.3 351.1 319.1 351.1zM320 191.1c-70.25 0-137.9 25.6-190.5 72.03C116.3 275.7 115 295.9 126.7 309.2C138.5 322.4 158.7 323.7 171.9 312C212.8 275.9 265.4 256 320 256s107.3 19.88 148.1 56C474.2 317.4 481.8 320 489.3 320c8.844 0 17.66-3.656 24-10.81C525 295.9 523.8 275.7 510.5 264C457.9 217.6 390.3 191.1 320 191.1zM630.2 156.7C546.3 76.28 436.2 32 320 32S93.69 76.28 9.844 156.7c-12.75 12.25-13.16 32.5-.9375 45.25c12.22 12.78 32.47 13.12 45.25 .9375C125.1 133.1 220.4 96 320 96s193.1 37.97 265.8 106.9C592.1 208.8 600 211.8 608 211.8c8.406 0 16.81-3.281 23.09-9.844C643.3 189.2 642.9 168.1 630.2 156.7z"></path></svg>
              <h2>Einrichtung</h2>
              <h3>Server</h3>
              <div style="display: flex;">
                <div class="input">
                  <!-- <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="server" class="svg-inline--fa fa-server fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M480 288H32c-17.62 0-32 14.38-32 32v128c0 17.62 14.38 32 32 32h448c17.62 0 32-14.38 32-32v-128C512 302.4 497.6 288 480 288zM352 408c-13.25 0-24-10.75-24-24s10.75-24 24-24s24 10.75 24 24S365.3 408 352 408zM416 408c-13.25 0-24-10.75-24-24s10.75-24 24-24s24 10.75 24 24S429.3 408 416 408zM480 32H32C14.38 32 0 46.38 0 64v128c0 17.62 14.38 32 32 32h448c17.62 0 32-14.38 32-32V64C512 46.38 497.6 32 480 32zM352 152c-13.25 0-24-10.75-24-24S338.8 104 352 104S376 114.8 376 128S365.3 152 352 152zM416 152c-13.25 0-24-10.75-24-24S402.8 104 416 104S440 114.8 440 128S429.3 152 416 152z"></path></svg> -->
                  <ion-input  autocomplete="off" autocapitalize="none" type="text" [(ngModel)]="serverAddress" placeholder="z.B.: 192.168.0.1"></ion-input>
                  <!-- <input autocomplete="off" autocapitalize="none" type="text" [(ngModel)]="serverAddress" class="search-input" placeholder="z.B.: 192.168.0.1"/> --> 
                </div>
                <div class="c-bttn main-button" style="margin-left: 5px;" (click)="finish(2)">
                  <svg style="margin: 0; height: 18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path style="fill: #fff;" d="M144 32C170.5 32 192 53.49 192 80V176C192 202.5 170.5 224 144 224H48C21.49 224 0 202.5 0 176V80C0 53.49 21.49 32 48 32H144zM128 96H64V160H128V96zM144 288C170.5 288 192 309.5 192 336V432C192 458.5 170.5 480 144 480H48C21.49 480 0 458.5 0 432V336C0 309.5 21.49 288 48 288H144zM128 352H64V416H128V352zM256 80C256 53.49 277.5 32 304 32H400C426.5 32 448 53.49 448 80V176C448 202.5 426.5 224 400 224H304C277.5 224 256 202.5 256 176V80zM320 160H384V96H320V160zM352 448H384V480H352V448zM448 480H416V448H448V480zM416 288H448V416H352V384H320V480H256V288H352V320H416V288z"/></svg>
                </div>
              </div>
      
              <div id="serverlist">
                <h3 *ngIf="serverList.length > 0">Gefundene Server:</h3>
                <ion-item *ngFor="let server of serverList" class="serverlist-item" (click)="selectServerByList(server)">
                  <ion-avatar>
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="rss" class="svg-inline--fa fa-rss" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M25.57 176.1C12.41 175.4 .9117 185.2 .0523 198.4s9.173 24.65 22.39 25.5c120.1 7.875 225.7 112.7 233.6 233.6C256.9 470.3 267.4 480 279.1 480c.5313 0 1.062-.0313 1.594-.0625c13.22-.8438 23.25-12.28 22.39-25.5C294.6 310.3 169.7 185.4 25.57 176.1zM32 32C14.33 32 0 46.31 0 64s14.33 32 32 32c194.1 0 352 157.9 352 352c0 17.69 14.33 32 32 32s32-14.31 32-32C448 218.6 261.4 32 32 32zM63.1 351.9C28.63 351.9 0 380.6 0 416s28.63 64 63.1 64s64.08-28.62 64.08-64S99.37 351.9 63.1 351.9z"></path></svg>
                  </ion-avatar>
                  <ion-label> 
                    <h3>{{server.hostname}}</h3>
                    <h4 *ngIf="!server.domainName">{{server.ipv4}}</h4>
                    <h4 *ngIf="server.domainName">{{server.domainName}}</h4>
                  </ion-label> 
                </ion-item>
              </div>
      
              <ion-button color="none" mode="ios"  fill="clear" (click)="setupNext()">
                Weiter 
                <ion-icon name="fa-arrow-right" slot="end"></ion-icon>
              </ion-button>
    
            </div>
          </swiper-slide>

          <swiper-slide>
            <div>
              <div class="error-report-item">
                <div>
                  <div class="error-report-header">Fehlerberichte senden</div>
                  <p>
                    Tragen Sie dazu bei die Qualität unserer Dienstleistungen zu verbessern. <br>
                  </p>
                  <span (click)="openSentryText()">Mehr erfahren...</span>
                </div>
                <ion-toggle mode="ios" [(ngModel)]="isSentryEnabled"></ion-toggle>
              </div>

              <h2>Theme</h2>
              <div id="theme-selection">
                <div id="t-light" class="t-out" [class.active]="!(darkmode.isDarkMode | async)" (click)="darkmode.setDarkmode('light')">
                  <div class="theme">
                    <div class="t-ball"></div>
                    <div class="t-row"></div>
                    <div class="t-row"></div>
                    <div class="t-row"></div>
                    <div class="t-row"></div>
                  </div>
                  <div class="t-checked" *ngIf="!(darkmode.isDarkMode | async)">
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"></path></svg>
                  </div>
                </div>
                <div id="t-dark" class="t-out" [class.active]="(darkmode.isDarkMode | async)" (click)="darkmode.setDarkmode('dark')">
                  <div class="theme">
                    <div class="t-ball"></div>
                    <div class="t-row"></div>
                    <div class="t-row"></div>
                    <div class="t-row"></div>
                    <div class="t-row"></div>
                  </div>
                  <div class="t-checked" *ngIf="(darkmode.isDarkMode | async)">
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"></path></svg>
                  </div>
                </div>
              </div>
              <ion-button color="none" mode="ios"  fill="clear" (click)="finish()">
                Jetzt starten
                <ion-icon name="fa-arrow-right" slot="end"></ion-icon>
              </ion-button>
            </div>
          </swiper-slide>

      </swiper-container>
    <!-- </ion-slide>  -->

    <!-- <ion-slide> -->

    <!-- </ion-slide>   -->

    <!-- <ion-slide> -->

    <!-- </ion-slide> -->


    <!-- <ion-slide>
      <section [class.colorAnimate]="colorAnimate">
        <div class="ticket-color">
          <div class="ticket-icon" id="red">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ticket" class="svg-inline--fa fa-ticket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M128 352h320v-192H128V352zM576 208V112c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v95.1c26.5 0 48 21.5 48 47.1S26.5 304 0 304v96c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-96c-26.5 0-48-21.5-48-48S549.5 208 576 208zM480 360c0 13.25-10.75 24-24 24H120c-13.25 0-24-10.75-24-24V152c0-13.25 10.75-24 24-24h336c13.25 0 24 10.75 24 24V360z"></path></svg>
          </div>
          <div>
            <h2>Rot</h2>
            <p>Kennzeichnet, dass ein Ticket den "offenen" Status besitzt und deshalb noch bearbeitet werden muss.</p>
          </div>
        </div>
        <div class="ticket-color">
          <div class="ticket-icon" id="yellow">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ticket" class="svg-inline--fa fa-ticket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M128 352h320v-192H128V352zM576 208V112c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v95.1c26.5 0 48 21.5 48 47.1S26.5 304 0 304v96c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-96c-26.5 0-48-21.5-48-48S549.5 208 576 208zM480 360c0 13.25-10.75 24-24 24H120c-13.25 0-24-10.75-24-24V152c0-13.25 10.75-24 24-24h336c13.25 0 24 10.75 24 24V360z"></path></svg>
          </div>
          <div>
            <h2>Gelb</h2>
            <p>Das Ticket befindet sich in dem Status "Warten auf Antwort".</p>
          </div>
        </div>
        <div class="ticket-color">
          <div class="ticket-icon" id="green">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ticket" class="svg-inline--fa fa-ticket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M128 352h320v-192H128V352zM576 208V112c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v95.1c26.5 0 48 21.5 48 47.1S26.5 304 0 304v96c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-96c-26.5 0-48-21.5-48-48S549.5 208 576 208zM480 360c0 13.25-10.75 24-24 24H120c-13.25 0-24-10.75-24-24V152c0-13.25 10.75-24 24-24h336c13.25 0 24 10.75 24 24V360z"></path></svg>
          </div>
          <div>
            <h2>Grün</h2>
            <p>Dieser Status besagt, dass das Ticket sich im Status "Abgeschlossen" befindet.</p>
          </div>
        </div>
        <ion-button color="none" mode="ios"  fill="clear" (click)="finish()" >
          Jetzt starten
          <ion-icon name="fa-arrow-right" slot="end"></ion-icon>
        </ion-button>
      </section>
    </ion-slide> -->


  <!-- </ion-slides> -->
</ion-content>
